
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_32007_149847)"}},[_c('path',{attrs:{"d":"M6.07 4.75a1.751 1.751 0 01-3.5 0 1.751 1.751 0 013.5 0zM2.32 9.678c-.312.35-.5.816-.5 1.322 0 .506.188.972.5 1.322V9.678zm4.513-1.54A4.48 4.48 0 005.32 11.5a4.48 4.48 0 001 2.828V15c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1v-.838A3.502 3.502 0 013.82 7.5h1c.75 0 1.444.234 2.013.634v.003zM14.32 15v-.672a4.48 4.48 0 001-2.828c0-1.338-.584-2.54-1.512-3.366A3.485 3.485 0 0115.82 7.5h1a3.501 3.501 0 011.5 6.662V15c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1zm3.75-10.25a1.751 1.751 0 01-3.5 0 1.751 1.751 0 013.5 0zm.25 4.928v2.647c.313-.353.5-.816.5-1.322a1.98 1.98 0 00-.5-1.322v-.003zM10.32 7c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm-2.5 4.5c0 .506.188.969.5 1.322v-2.644c-.312.353-.5.816-.5 1.322zm4.5-1.322v2.647c.313-.353.5-.816.5-1.322a1.98 1.98 0 00-.5-1.322v-.003zm2 1.322c0 1.397-.818 2.6-2 3.162V16c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1v-1.338A3.502 3.502 0 019.82 8h1c1.935 0 3.5 1.566 3.5 3.5z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_32007_149847"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.32 2)","d":"M0 0h20v16H0z"}})])])])
          )
        }
      }
    